import { Button, Modal } from 'react-bootstrap';

import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { NewRequestModalData, newRequestModalDefaults } from '../utils';

export const ItemModal = (props: any) => {
  const [visible, setVisible] = useState(false);
  const { register, getValues, handleSubmit, reset } = useForm<NewRequestModalData>({
    defaultValues: {
      chargeAccount: props.item.chargeAccount,
      equipmentCategory: props.item.equipmentCategory,
      equipmentType: props.item.equipmentType,
      notes: props.item.notes,
      quantity: props.item.quantity,
      status: 'Requested',
      id: props.item.id,
    },
  });

  React.useEffect(() => {
    if (props.create) reset(newRequestModalDefaults);
  }, [props.items, reset, props.create]);

  const onSubmit = handleSubmit((data) => {
    if (!props.create) {
      props.items.splice(getValues('id'), 1, data);
      //updates state with itself, since ^ line mutates array
      props.setItems((items) => [...items]);
    } else {
      props.setItems([...props.items, data]);
    }
    setVisible(false);
  });

  type EquipmentType = {id: number, display: string, value: string}
  const equipmentTypes: EquipmentType[] = [
    {id: 0, display: '', value: ''},
    {id: 1, display: 'Desktop', value: 'DES'},
    {id: 2, display: 'Laptop', value: 'LAP'},
    {id: 3, display: 'Monitor', value: 'MON'},
    {id: 4, display: 'Printer', value: 'PRI'},
    {id: 5, display: 'Other', value: 'OTH'}
  ]
    // = ['', 'Desktop', 'Laptop', 'Monitor', 'Printer', 'Other'];


  return (
    <div>
      <Button
        onClick={() => {
          setVisible(true);
        }}
        variant='info'
        size='sm'>
        {!props.create ? <i className='fa fa-pen' /> : (props.nonOIT ? '+ Add Item' : '+ Add Hardware Item')}
      </Button>
      <Modal dialogClassName='modal-half-width' show={visible} onHide={() => setVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <strong>Add/Edit Hardware</strong>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id='form' onSubmit={onSubmit}>
            <div className='row justify-content-start'>
              <div className='col-sm-8'>
                <div className='form-group'>
                  <label>Equipment Type&nbsp;&nbsp;</label>
                  <span className='text-primary'>*</span>
                  <input
                    className='form-control '
                    {...register('equipmentType', {
                      required: true,
                    })}
                  />
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-4'>
                <div className='form-group'>
                  <label>Equipment&nbsp;Category&nbsp;&nbsp;{<span className='text-primary'>*</span>}</label>
                  <select
                    className='form-control'
                    {...register('equipmentCategory', {
                      required: true,
                    })}>
                    {equipmentTypes.map((item, index) => {
                      return <option id={item.id.toString()} value={item.value}>{item.display}</option>;
                    })}
                  </select>
                </div>
              </div>
              <div className='col-sm-2'>
                <div className='form-group'>
                  <label>Quantity&nbsp;&nbsp;{<span className='text-primary'>*</span>}</label>
                  <input
                    type='number'
                    className='form-control'
                    {...register('quantity', {
                      required: true,
                    })}
                  />
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-5'>
                <div className='form-group'>
                  <label>Harbor Charge Account&nbsp;&nbsp;</label>
                  <input id='chargeAccount' name='chargeAccount' className='form-control' {...register('chargeAccount')} />
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-8'>
                <div className='form-group'>
                  <label>Notes&nbsp;&nbsp;</label>
                  <textarea className='form-control' rows={3} {...register('notes')} />
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button type='submit' form='form'>
            {!props.create ? 'Update' : 'Add'}
          </Button>
          <Button variant='info' onClick={() => setVisible(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
